import { useState, useEffect } from "react";
import BcToogle from "../Bc-Toggle/Bc-Toogle";
import { Helmet } from "react-helmet-async";

const KEY = "theme";

const {REACT_APP_SDB_URL, REACT_APP_SDB_VERSION, REACT_APP_SDB_THEME_DARK, REACT_APP_SDB_THEME_LIGHT} = process.env;

const THEME_DARK = `${REACT_APP_SDB_URL}/${REACT_APP_SDB_VERSION}/${REACT_APP_SDB_THEME_DARK}`;
const THEME_LIGHT = `${REACT_APP_SDB_URL}/${REACT_APP_SDB_VERSION}/${REACT_APP_SDB_THEME_LIGHT}`;

const ThemeSwitcher = () => {
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem(KEY);

    if (savedTheme) return savedTheme;

    const windowMatch = window.matchMedia("(prefers-color-scheme: dark)");
    return windowMatch.matches ? "dark" : "light";
  }); 

  const reloadPage = () => {
    window.location.reload()
  }

  useEffect(() => {
    localStorage.setItem(KEY, theme);
  }, [theme]);

  return (
    <>
      <Helmet>
        <link
          rel="stylesheet"
          href={`${
            theme === "dark"
              ? THEME_DARK
              : THEME_LIGHT
          }`}
        />
      </Helmet>
      <BcToogle
        name="theme"
        onChange={(e: any) => {
          setTheme(e.target.checked ? "dark" : "light");
          reloadPage();
        }}
        checked={theme === "dark" ? true : false}
      />
    </>
  );
};

export default ThemeSwitcher;
